/* eslint-disable react/require-default-props */
import { useMeasureFormatter } from './measureFormatter';
import { MeasureUnitConfig } from './MeasureUnitConfig';
import { MeasureUnitInfo } from './MeasureUnitInfo';
import { MeasureUnitCode } from './MeasureUnitCode';
import { cn } from 'utils/classNamesTailwind';

export function MeasureFormat({
  value,
  unit,
  config,
  rate,
  signedPositive = false,
  className = '',
}: {
  value?: number;
  unit: MeasureUnitCode | MeasureUnitInfo;
  config?: MeasureUnitConfig;
  rate?: number;
  signedPositive?: boolean;
  className?: string;
}) {
  const { measureFormatter } = useMeasureFormatter();

  return (
    <span className={cn('whitespace-nowrap', className)}>
      {signedPositive ? '+' : ''}
      {measureFormatter(value, unit, config, rate)}
    </span>
  );
}
